// Отличает "сервер однозначно отверг учётные данные" (401/403) от временного
// сбоя (сеть не поднялась после сна/разблокировки, таймаут, 5xx при рестарте
// бэкенда). Только первое - повод стирать токены: refresh-токен живёт 7 дней,
// и один неудачный запрос сразу после долгого простоя не должен его убивать.
export function isAuthRejection(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  return status === 401 || status === 403;
}
